import React from 'react';
import BrandManagement from '../../components/templates/admin/BrandManagement';

const BrandManagementPage = () => {
  return <BrandManagement />;
};

export default BrandManagementPage;
